import {gql} from '@apollo/client'

const clientSchema = gql`
    extend type Query {
        isThemeEditor: Boolean!
        isXcEditor: Boolean!
        isCufeApp: Boolean!
        isEufeApp: Boolean!
        currentContactPerson: MemberType
        currentOffice: OfficeType
        currentOrgId: ID
    }

    extend type Mutation {
        isThemeEditor: Boolean!
        isXcEditor: Boolean!
        isCufeApp: Boolean!
        isEufeApp: Boolean!
    }

    extend type Subscription {
        isThemeEditor: Boolean!
        isXcEditor: Boolean!
        isCufeApp: Boolean!
        isEufeApp: Boolean!
    }
`

export default clientSchema
